import React from 'react';
import CameraComponent from "../components/cameraComponent";
import App from "../App";

const CameraPage = () => {
    return (
        <>
            <App/>
            <CameraComponent/>
        </>
    );
};

export default CameraPage;